import { render, staticRenderFns } from "./EventsScreen.vue?vue&type=template&id=32d2b04e&scoped=true"
import script from "./EventsScreen.vue?vue&type=script&lang=js"
export * from "./EventsScreen.vue?vue&type=script&lang=js"
import style0 from "./EventsScreen.vue?vue&type=style&index=0&id=32d2b04e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2b04e",
  null
  
)

export default component.exports